module.exports = __webpack_public_path__ + "img/medal.1c1f3a63.svg";